import { css } from '@emotion/react';
import { Paragraph, tokens } from '@flysas-tech/commercial-ui';
import { useState } from 'react';
import { formatCurrency } from 'shared';

import { LinkAsButton } from '../atoms';

import { PriceDetails } from './PassengerCardBreakdown';
import { PriceItem } from './types';

const styles = {
  itemLabel: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  listWrapper: css`
    width: 100%;
  `,
  breakdownContainer: css`
    margin-top: ${tokens.dimension['space-2']};
  `,
};

type Props = {
  pos: string;
  item: PriceItem;
  showTotalPrice?: boolean;
};

export const PriceBreakdown = ({ item, pos, showTotalPrice = true }: Props) => {
  const [isExpanded, setExpanded] = useState<string | null>(null);
  const priceDetails =
    item.breakdown?.map(({ name, price }) => ({
      label: name,
      price: formatCurrency(price, pos),
    })) || [];

  return (
    <div css={styles.listWrapper}>
      <div css={styles.itemLabel}>
        {priceDetails.length > 0 ? (
          <LinkAsButton onClick={() => setExpanded(prev => (prev === item.label ? null : item.label))}>
            {item.label}
          </LinkAsButton>
        ) : (
          <Paragraph color={'primary'} size={'paragraph-2'}>
            {item.label}
          </Paragraph>
        )}

        {showTotalPrice && (
          <Paragraph size="paragraph-2" color="primary">
            {typeof item.value === 'string' ? item.value : formatCurrency(item.value, pos)}
          </Paragraph>
        )}
      </div>

      {isExpanded === item.label && (
        <div css={styles.breakdownContainer}>
          <PriceDetails priceDetails={priceDetails} pos={pos} />
        </div>
      )}
    </div>
  );
};
